import React, { useState } from 'react';

const HologramModal = ({ isOpen, onClose, onGenerate }) => {
    const [hologramType, setHologramType] = useState('rainbow'); // rainbow, globe, geometric
    const [opacity, setOpacity] = useState(0.5);
    const [angle, setAngle] = useState(45);

    if (!isOpen) return null;

    const handleGenerate = () => {
        onGenerate({
            hologramType,
            opacity: Number(opacity),
            angle: Number(angle),
            customType: 'hologram'
        });
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col">
                <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-gray-50">
                    <h3 className="font-bold text-lg text-gray-800">Configurar Holograma</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Holograma</label>
                        <div className="grid grid-cols-3 gap-3">
                            {[
                                { id: 'rainbow', label: 'Arcoíris', color: 'bg-gradient-to-r from-red-400 via-green-400 to-blue-400' },
                                { id: 'globe', label: 'Mundo', color: 'bg-blue-100 border-blue-300' }, // Placeholder visual
                                { id: 'geometric', label: 'Geométrico', color: 'bg-gray-100 border-gray-300' }
                            ].map((type) => (
                                <button
                                    key={type.id}
                                    onClick={() => setHologramType(type.id)}
                                    className={`p-2 rounded-lg border-2 flex flex-col items-center space-y-2 transition-all ${hologramType === type.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`}
                                >
                                    <div className={`w-10 h-10 rounded ${type.color} shadow-sm`}></div>
                                    <span className="text-xs font-medium text-gray-700">{type.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Opacidad ({Math.round(opacity * 100)}%)</label>
                        <input
                            type="range"
                            min="0.1"
                            max="0.9"
                            step="0.1"
                            value={opacity}
                            onChange={(e) => setOpacity(e.target.value)}
                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Ángulo de Reflejo ({angle}°)</label>
                        <input
                            type="range"
                            min="0"
                            max="360"
                            step="15"
                            value={angle}
                            onChange={(e) => setAngle(e.target.value)}
                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        />
                    </div>
                </div>

                <div className="p-4 border-t border-gray-200 bg-gray-50 flex justify-end space-x-3">
                    <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">Cancelar</button>
                    <button onClick={handleGenerate} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Insertar Holograma</button>
                </div>
            </div>
        </div>
    );
};

export default HologramModal;
